import {PAGINATION_PARAM_NAMES} from '../../common/pagination/paginationConstants';
import {
  generateSeoInfo,
} from '../../modules/seo/seoUtils';

function generateDefaultInitialCategoryState() {
  return {
    isClosedCategory: false,
    categoryBreadcrumbArray: null,
    categorySeoInfo: null,
    subCategories: null,
    categoryProductArray: null,
    categoryProductPaginationParams: {
      pageNumber: 1,
    },
    initialPageNumber: null,
    totalCategoryProductCount: 0,
    categorySearchContext: null,
    categories: null,
    isFetching: false,
    algKey: '',
    cardType: null,
    keywords: [],
  };
}

function categoryReducer(state = generateDefaultInitialCategoryState(), action) {
  let newState;
  switch (action.type) {
    case 'GET_CATEGORY_PRODUCTS': {
      newState = {
        ...state,
        isFetching: true
      }

      break;
    }
    case'GET_CATEGORY_PRODUCTS_FULFILLED': {
      const {
        breadcrumbs,
        products,
        totalProductCount,
        seoInformation: rawSeoInformation,
        isClosedCategory,
        searchPass,
        searchContext,
        categories,
        townToTownEAD,
        cardType,
        isActiveAddToCart,
        al_g: algKey,
      } = action.payload.response.data.data || {};
      const seoInformationData = generateSeoInfo(rawSeoInformation);

      newState = {
        ...state,
        isFetching: false,
        isClosedCategory,
        categoryProductArray: products,
        algKey,
        totalCategoryProductCount: totalProductCount,
        categoryBreadcrumbArray: breadcrumbs,
        categorySeoInfo: seoInformationData,
        categoryShippingType: generateSeoInfo(rawSeoInformation) && generateSeoInfo(rawSeoInformation).utagData ? generateSeoInfo(
          rawSeoInformation,
        ).utagData.shipping_type : '',
        categorySearchPass: searchPass,
        categoryProductPaginationParams: {
          ...state.categoryProductPaginationParams,
          ...action.triggerPayload.params,
          pageNumber:
            parseInt(action.triggerPayload.params[PAGINATION_PARAM_NAMES.PAGE], 10),
        },
        initialPageNumber: action.triggerPayload.params[PAGINATION_PARAM_NAMES.PAGE],
        categorySearchContext: searchContext,
        categoryName: categories && categories[0] ? categories[0].name : null,
        townToTownEAD,
        cardType,
        isActiveAddToCart
      };

      break;
    }

    case 'GET_SEO_INFORMATION_CATEGORY': {
      newState = {
        ...state,
        isFetching: true
      }

      break;
    }
    case'GET_SEO_INFORMATION_CATEGORY_FULFILLED': {
      const {
        seoInformation: rawSeoInformation,
      } = action.payload.response.data.data || {};
      const seoInformationData = generateSeoInfo(rawSeoInformation);

      newState = {
        ...state,
        isFetching: false,
        categorySeoInfo: seoInformationData,
      };

      break;
    }

    case'GET_NEXT_CATEGORY_PRODUCTS_FULFILLED': {
      const {
        products,
        totalProductCount,
        seoInformation: rawSeoInformation,
        townToTownEAD,
        cardType,
      } = action.payload.response.data.data;

      newState = {
        ...state,
        categoryProductArray: state.categoryProductArray.concat(
          products,
        ),
        categorySeoInfo: generateSeoInfo({
          ...rawSeoInformation,
          h2: state?.categorySeoInfo?.h2,
          searchKeywordArray: state?.categorySeoInfo?.searchKeywordArray,
          seoParagraph: state?.categorySeoInfo?.seoParagraph,
          questions: state?.categorySeoInfo?.questions,
        }),
        categoryShippingType: generateSeoInfo(rawSeoInformation) && generateSeoInfo(rawSeoInformation)?.utagData ? state?.categoryShippingType?.concat(
          generateSeoInfo(rawSeoInformation)?.utagData?.shipping_type,
        ) : '',
        totalCategoryProductCount: totalProductCount,
        categoryProductPaginationParams: {
          ...state.categoryProductPaginationParams,
          ...action.triggerPayload.params,
          pageNumber:
            parseInt(action.triggerPayload.params[PAGINATION_PARAM_NAMES.PAGE], 10),
        },
        townToTownEAD,
        cardType,
      };

      break;
    }

    case 'GET_CATEGORY_INFORMATION_FULFILLED': {
      const {
        seoInformation: rawSeoInformation,
        subCategories,
        breadcrumbs,
        categories,
      } = action.payload.response.data.data;

      newState = {
        ...state,
        categoryBreadcrumbArray: breadcrumbs,
        categorySeoInfo: generateSeoInfo(rawSeoInformation),
        subCategories: subCategories,
        categories: categories,
      };
      break;
    }
    case 'GET_KEYWORDS_FULFILLED': {
      const data = action?.payload?.response?.data?.data;
      newState = {
        ...state,
        keywords: data,
      };
      break;
    }

    case 'RESET_CATEGORY_PRODUCTS': {
      newState = {
        ...state,
        categoryProductArray: null,
        categoryProductPaginationParams: {
          pageNumber: 1,
        },
        initialPageNumber: null,
        totalCategoryProductCount: 0,
      };

      break;
    }

    case 'LEAVE_CATEGORY_PAGE_ROUTE':
    case 'LEAVE_BRAND_CATEGORY_PAGE_ROUTE': {
      newState = {
        ...state,
        isClosedCategory: false,
        categoryProductArray: null,
        categoryBreadcrumbArray: null,
        categorySeoInfo: null,
        subCategories: null,
        categoryProductPaginationParams: {
          pageNumber: 1,
        },
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default categoryReducer;
export {generateDefaultInitialCategoryState};
